import styled from 'styled-components';
import { colors } from '@prisjakt/ui-base';

export const ProductFinder = styled.div`
  color: ${colors.white};
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  flex-direction: column;
  border-radius: 7px;
  position: relative;
  width: 100%;
`;
